import { CheckboxContainer } from "./styles";

const Checkbox = ({ label, checked, onChange }) => {
  return (
    <CheckboxContainer>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <label>{label}</label>
    </CheckboxContainer>
  );
};

export default Checkbox;
